import { useTranslation } from 'libs/i18n'
import type { Option } from 'shared/components/ContextMenu/types'
import type { TypeItem } from 'features/types/types/types.types'

type UseContextMenuOptionsProps = {
	onEdit: (productType: TypeItem) => void
	onDelete: (id: number) => void
}

export const useContextMenuOptions = ({
	onEdit,
	onDelete
}: UseContextMenuOptionsProps): Option[] => {
	const { t } = useTranslation()

	return [
		{
			label: t('Edit'),
			action: (_id: number, productType: TypeItem) => onEdit(productType)
		},
		{
			label: t('Delete'),
			action: onDelete
		}
	]
}
